export default function getSalesforceUrl(salesforceId?: string): string {
  if (!salesforceId) return ''

  let activeEnvironment = 'dev'

  if (
    window.location.hostname.includes('app.1edtech.org') ||
    window.location.hostname.includes('staging.1edtech.org')
  ) {
    activeEnvironment = 'prod'
  }

  const salesforceUrls: { [key: string]: string } = {
    dev: 'https://1edtech--partialsa.sandbox.lightning.force.com',
    prod: 'https://1edtech.lightning.force.com',
  }

  const baseUrl =
    activeEnvironment === 'prod'
      ? salesforceUrls['prod']
      : salesforceUrls['dev']

  return `${baseUrl}/lightning/r/Account/${salesforceId}/view`
}
